import styled, { css } from 'styled-components';

type ContainerProps = {
  $hasAction?: boolean;
};

export const Container = styled.div<ContainerProps>`
  ${({ $hasAction }) => css`
    display: grid;
    grid-gap: 0.75rem;
    align-items: center;
    grid-template-columns: ${$hasAction ? '2rem auto' : '100%'};
    grid-auto-rows: 2rem;
  `}
`;
